import React, { useEffect, useState, Fragment } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage/StandardPage'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiResponse } from '../../typings/ApiResponse'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'
import { usePagination } from '../../hooks/usePagination'
import { GenericTable } from '../../components/_EOS/Table/GenericTable'
import { GenericOrderBy } from '../../components/_EOS/Table/types'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { IconButton, Tooltip } from '@mui/material'
import { Description, CloudDownload } from '@mui/icons-material'
import { CustomActionsProps, ProcessEntity } from './Types/entities'
import { getProcessList, getUrlOriginalFile, getUrlResultFile } from './api'
import { useSnackbar } from '../../hooks/useSnackbar'
import { ProcessSearch } from '../../components/ProcessNew/ProcessSearch'
import { downloadBase64File, generateTableHeaders } from './config/config'

interface ProductPageProps {}

export const ProcessNew: React.FC<ProductPageProps> = () => {
  const { state, callApi } = useApi<ApiResponse<ProcessEntity>>()
  const { callApi: callApiGetResultFile } = useApi<ApiResponse<ProcessEntity>>()
  const { callApi: callApiGetOriginalUrlFile } =
    useApi<ApiResponse<ProcessEntity>>()
  const { isActive, isSuccess, message } = useSnackbar()
  const [selectedFilters, setSelectedFilters] = useState<Filter[]>([])
  const [loadingForm, setloadingForm] = useState(false)
  const pagination = usePagination(10)

  const requestProcess = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    callApi(getProcessList(filters, page, pageSize)).catch((error) => {
      console.log(error)
    })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestProcess(selectedFilters, auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  const [orderBy] = useState<GenericOrderBy<ProcessEntity>>({
    field: '',
    direction: 'desc'
  })

  const handleDownloadResultFile = (processId: number) => {
    callApiGetResultFile(getUrlResultFile(processId))
      .then((data) => {
        downloadBase64File(data.file, data.name, data.mimeType)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleDownloadOriginalFile = (processId: number) => {
    callApiGetOriginalUrlFile(getUrlOriginalFile(processId))
      .then((data) => {
        downloadBase64File(data.file, data.name, data.mimeType)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    setloadingForm(true)
    pagination.setPagination(0, pagination.pageSize)
    requestProcess(selectedFilters, 0, pagination.pageSize)
    setloadingForm(false)
  }, [orderBy, selectedFilters])

  const MyCustomActions: React.FC<CustomActionsProps> = ({ row }) => {
    return (
      <Fragment>
        <Tooltip title='Archivo Original' aria-label='edit'>
          <IconButton
            disabled={!row.fileName}
            aria-label='seeBinacle'
            onClick={() => handleDownloadOriginalFile(row.processId)}
            style={{ verticalAlign: 'bottom' }}
          >
            <Description />
          </IconButton>
        </Tooltip>
        <Tooltip title='Resultado Carga' aria-label='edit'>
          <IconButton
            disabled={!row.urlFileResulting}
            aria-label='seeBinacle'
            onClick={() => handleDownloadResultFile(row.processId)}
            style={{ verticalAlign: 'bottom' }}
          >
            <CloudDownload />
          </IconButton>
        </Tooltip>
      </Fragment>
    )
  }

  const tableHeadersProcess = generateTableHeaders()
  return (
    <Fragment>
      <StandardPage pageTitle='Procesos'>
        <ProcessSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={requestProcess}
        />

        <GenericTable<ProcessEntity>
          headersConfig={tableHeadersProcess}
          IDKey={'processId'}
          data={state.data?.items}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading || loadingForm}
          showCheckboxes={false}
          orderField={orderBy}
          customActionComponent={MyCustomActions}
        />
      </StandardPage>
      <SnackBar
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
        message={message}
      />
    </Fragment>
  )
}
